// Presenza del popup SIP rilevata via Web Locks invece che via heartbeat.
// Speculare a mainPresence.ts, che risolve il problema simmetrico (il popup che
// deve distinguere "tutte le main chiuse" da "main solo in background").
//
// Il popup owner tiene il lock esclusivo `gaia-sip-owner` per tutta la sua vita
// (vedi acquireOwnerLock). Un lock TENUTO non è soggetto al throttling dei timer
// in background — a differenza dell'heartbeat da 2s — e il browser lo rilascia da
// sé quando la finestra muore. È quindi l'unico segnale affidabile per rispondere
// a "esiste già un popup?" prima di chiamare window.open(url, POPUP_WINDOW_NAME),
// che su una finestra già aperta la NAVIGA, uccidendo la chiamata in corso
// (GAIA-2674).

import { OWNER_LOCK_NAME } from "@/components/SIPIntegration/composables/useSipOwnerLock";

/**
 * Da chiamare nella MAIN app. Ritorna:
 * - true  → un popup SIP tiene il lock owner (vivo, magari throttlato o congelato)
 * - false → nessun popup owner presente
 * - null  → API Web Locks non disponibile (il chiamante deve ricadere sull'heartbeat)
 */
export async function isSipOwnerPresent(): Promise<boolean | null> {
  if (!("locks" in navigator)) return null;
  try {
    const state = await navigator.locks.query();
    return (state.held ?? []).some((lock) => lock.name === OWNER_LOCK_NAME);
  } catch {
    return null;
  }
}
